module.exports = __webpack_public_path__ + "static/media/johnErickson.de37c1a2.jpg";